module.exports = __webpack_public_path__ + "assets/img/Large_3.3084b9a7.svg";